// import "@angular/platform-browser-dynamic";

import { enableProdMode } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

Sentry.init({
  dsn: 'https://7fbe9c5c19224c86fd75c0509d5ca6be@o4506716496199680.ingest.sentry.io/4506717765500928',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring (reduce noise / 429s)
  tracesSampleRate: 0.02,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/memorabid\.com\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.02,
  replaysOnErrorSampleRate: 0.2,
});
if (environment.production) {
  enableProdMode();
}

function bootstrap() {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
}

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
